// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for Amazon Route 53 Domains (ROUTE53DOMAINS)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53domains.html
 *
 * 2025-02-24T21:49:29.452Z
 */
export enum AwsRoute53domainsActions {
  /**
   * Grants permission to accept the transfer of a domain from another AWS account t
   * o the current AWS account
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_AcceptDomainTransferFromAnotherAwsAccount.html
   */
  AcceptDomainTransferFromAnotherAwsAccount = 'route53domains:AcceptDomainTransferFromAnotherAwsAccount',
  /**
   * Grants permission to associate a new delegation signer to a domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_AssociateDelegationSignerToDomain.html
   */
  AssociateDelegationSignerToDomain = 'route53domains:AssociateDelegationSignerToDomain',
  /**
   * Grants permission to cancel the transfer of a domain from the current AWS accou
   * nt to another AWS account
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_CancelDomainTransferToAnotherAwsAccount.html
   */
  CancelDomainTransferToAnotherAwsAccount = 'route53domains:CancelDomainTransferToAnotherAwsAccount',
  /**
   * Grants permission to check the availability of one domain name
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_CheckDomainAvailability.html
   */
  CheckDomainAvailability = 'route53domains:CheckDomainAvailability',
  /**
   * Grants permission to check whether a domain name can be transferred to Amazon R
   * oute 53
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_CheckDomainTransferability.html
   */
  CheckDomainTransferability = 'route53domains:CheckDomainTransferability',
  /**
   * Grants permission to delete domains
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_DeleteDomain.html
   */
  DeleteDomain = 'route53domains:DeleteDomain',
  /**
   * Grants permission to delete the specified tags for a domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_DeleteTagsForDomain.html
   */
  DeleteTagsForDomain = 'route53domains:DeleteTagsForDomain',
  /**
   * Grants permission to configure Amazon Route 53 to automatically renew the speci
   * fied domain before the domain registration expires
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_DisableDomainAutoRenew.html
   */
  DisableDomainAutoRenew = 'route53domains:DisableDomainAutoRenew',
  /**
   * Grants permission to remove the transfer lock on the domain (specifically the c
   * lientTransferProhibited status) to allow domain transfers
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_DisableDomainTransferLock.html
   */
  DisableDomainTransferLock = 'route53domains:DisableDomainTransferLock',
  /**
   * Grants permission to disassociate an existing delegation signer from a domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_DisassociateDelegationSignerFromDomain.html
   */
  DisassociateDelegationSignerFromDomain = 'route53domains:DisassociateDelegationSignerFromDomain',
  /**
   * Grants permission to configure Amazon Route 53 to automatically renew the speci
   * fied domain before the domain registration expires
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_DisableDomainAutoRenew.html
   */
  EnableDomainAutoRenew = 'route53domains:EnableDomainAutoRenew',
  /**
   * Grants permission to set the transfer lock on the domain (specifically the clie
   * ntTransferProhibited status) to prevent domain transfers
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_EnableDomainTransferLock.html
   */
  EnableDomainTransferLock = 'route53domains:EnableDomainTransferLock',
  /**
   * Grants permission to get information about whether the registrant contact has r
   * esponded for operations that require confirmation that the email address for th
   * e registrant contact is valid, such as registering a new domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_GetContactReachabilityStatus.html
   */
  GetContactReachabilityStatus = 'route53domains:GetContactReachabilityStatus',
  /**
   * Grants permission to get detailed information about a domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_GetDomainDetail.html
   */
  GetDomainDetail = 'route53domains:GetDomainDetail',
  /**
   * Grants permission to get a list of suggested domain names given a string, which
   * can either be a domain name or simply a word or phrase (without spaces)
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_GetDomainSuggestions.html
   */
  GetDomainSuggestions = 'route53domains:GetDomainSuggestions',
  /**
   * Grants permission to get the current status of an operation that is not complet
   * ed
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_GetOperationDetail.html
   */
  GetOperationDetail = 'route53domains:GetOperationDetail',
  /**
   * Grants permission to list all the domain names registered with Amazon Route 53
   * for the current AWS account
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_ListDomains.html
   */
  ListDomains = 'route53domains:ListDomains',
  /**
   * Grants permission to list the operation IDs of operations that are not yet comp
   * lete
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_ListOperations.html
   */
  ListOperations = 'route53domains:ListOperations',
  /**
   * Grants permission to list the prices of operations for TLDs
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_ListPrices.html
   */
  ListPrices = 'route53domains:ListPrices',
  /**
   * Grants permission to list all the tags that are associated with the specified d
   * omain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_ListTagsForDomain.html
   */
  ListTagsForDomain = 'route53domains:ListTagsForDomain',
  /**
   * Grants permission to change the IPS tag of .uk domain to initiate a transfer pr
   * ocess from Route 53 to another registrar
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_PushDomain.html
   */
  PushDomain = 'route53domains:PushDomain',
  /**
   * Grants permission to register domains
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_RegisterDomain.html
   */
  RegisterDomain = 'route53domains:RegisterDomain',
  /**
   * Grants permission to reject the transfer of a domain from another AWS account t
   * o the current AWS account
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_RejectDomainTransferFromAnotherAwsAccount.html
   */
  RejectDomainTransferFromAnotherAwsAccount = 'route53domains:RejectDomainTransferFromAnotherAwsAccount',
  /**
   * Grants permission to renew domains for the specified number of years
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_RenewDomain.html
   */
  RenewDomain = 'route53domains:RenewDomain',
  /**
   * Grants permission to resend the confirmation email to the current email address
   * for the registrant contact for operations that require confirmation that the em
   * ail address for the registrant contact is valid, such as registering a new doma
   * in
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_ResendContactReachabilityEmail.html
   */
  ResendContactReachabilityEmail = 'route53domains:ResendContactReachabilityEmail',
  /**
   * Grants permission to resend the operation authorization
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_ResendOperationAuthorization.html
   */
  ResendOperationAuthorization = 'route53domains:ResendOperationAuthorization',
  /**
   * Grants permission to get the AuthCode for the domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_RetrieveDomainAuthCode.html
   */
  RetrieveDomainAuthCode = 'route53domains:RetrieveDomainAuthCode',
  /**
   * Grants permission to transfer a domain from another registrar to Amazon Route 5
   * 3
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_TransferDomain.html
   */
  TransferDomain = 'route53domains:TransferDomain',
  /**
   * Grants permission to transfer a domain from the current AWS account to another
   * AWS account
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_TransferDomainToAnotherAwsAccount.html
   */
  TransferDomainToAnotherAwsAccount = 'route53domains:TransferDomainToAnotherAwsAccount',
  /**
   * Grants permission to update the contact information for domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_UpdateDomainContact.html
   */
  UpdateDomainContact = 'route53domains:UpdateDomainContact',
  /**
   * Grants permission to update the domain contact privacy setting
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_UpdateDomainContactPrivacy.html
   */
  UpdateDomainContactPrivacy = 'route53domains:UpdateDomainContactPrivacy',
  /**
   * Grants permission to replace the current set of name servers for a domain with
   * the specified set of name servers
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_UpdateDomainNameservers.html
   */
  UpdateDomainNameservers = 'route53domains:UpdateDomainNameservers',
  /**
   * Grants permission to add or update tags for a specified domain
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_UpdateTagsForDomain.html
   */
  UpdateTagsForDomain = 'route53domains:UpdateTagsForDomain',
  /**
   * Grants permission to get all the domain-related billing records for the current
   * AWS account for a specified period
   *
   * See https://docs.aws.amazon.com/Route53/latest/APIReference/API_domains_ViewBilling.html
   */
  ViewBilling = 'route53domains:ViewBilling',
}
